import styled from 'styled-components';

import {
  Grid as SemanticGrid,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const Grid = styled(SemanticGrid)`
  &&& {
    text-align: center;
    width: 100%;
    margin: 0px;
  }
`;

const Column = styled(SemanticGrid.Column)`
  &&& {
    font-size: 16px;
    word-wrap: break-word;
    align-self: center;
  }
`;

const ColumnText = styled(TextLayoutComponent.Span).attrs(() => ({
  fontSize: '16px',
}))`
`;

const Row = styled(SemanticGrid.Row)`
  &&& {
    align-self: center;

    :hover {
      cursor: pointer;
    }
  }
`;

const DismissButton = styled(ButtonLayoutComponent.Inverted)`
`;

const Icon = styled(SemanticIcon)`
`;

export {
  Column,
  ColumnText,
  DismissButton,
  Grid,
  Icon,
  Row,

};
